<template>
  <div id="bgImg">
       <div class="left-qr">
          <img src="../assets/Logo.png"  style="width: 86px; height: 86px; margin-bottom: 20px;">
          <h3 class="text-h3">滴滴叫修</h3>
          <div class="edition">
            <span>版本：1.0.0 大小：35.21 MB 更新时间：2021-10-08</span>
          </div>
          <div class="fer-text">
            全方位资源整合平台，拥有上万优质服务商，您可以在线报修设备，服务商急速为您的工单保驾护航，更有百万原厂配件等你来挑选。
          </div>
          <div class="qr-img">
              <div class="right-qr">
                <div class="qr-bg">
                  <img src="../assets/apple-qr.png"  style="width: 168px;height: 168px;">
                  <div class="rotate"></div>
                </div>
                <div class="butt bg-color">
                  <img src="../assets/apple-ico2.png"  style="width: 18px; height: 22px;">
                  <span class="butt-sp">iOS</span>
                </div>
              </div>
              <div>
                <div class="qr-bg">
                  <img src="../assets/android-qr.png"  style="width: 168px;height: 168px;">
                  <div class="rotate"></div>
                </div>
                <div class="butt bg-color2">
                  <img src="../assets/android-ico2.png"  style="width: 18px; height: 22px;">
                  <span class="butt-sp">Android</span>
                </div>
              </div>
          </div>
       </div>
       <div class="right-text">
         <img src="../assets/mobile-img.png" >
       </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{

      }
    }
  }
</script>

<style scoped>
  html,body{
    padding: 0;
    margin: 0;

  }
  #bgImg{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100vh;
    background-image: url(../assets/bg-img.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .left-qr{
    width: 24.5%;
    margin-left: 15%;
  }
  .rotate{
    position: absolute;
    bottom: -7.5px;
    left: 90px;
    width: 15px;
    height: 15px;
    background-color: #FFFFFF;
    transform:rotate(45deg);
  }
  .text-h3{
    color: #FFFFFF;
    margin-bottom: 22px;
  }
  .edition{
    font-size: 12px;
    color: #FFFFFF;
    margin-bottom: 35px;
  }
  .fer-text{
    font-size: 14px;
    color: #AEB0EC ;
    margin-bottom: 55px;
  }
  .qr-img{
    display: flex;
  }
  .right-qr{
    margin-right: 10%;
  }
  .qr-bg{
    background-color: #ffffff;
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 15px;
    position: relative;
  }
  .right-text{
    margin-right: 18%;
  }
  .butt{
    width: 125px;
    height: 38px;
    border-radius: 20px;
    line-height: 38px;
    text-align: center;
    margin: 0 auto;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .butt-sp{
    margin-left: 10px;
  }
  .bg-color{
    background-color: #1664FF;
  }
  .bg-color2{
    background-color: #17D3CF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/transfer.vue